import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import MobileAppPromo from '@zr/jobseeker-public/apps/jobseeker-collect-additional-information/components/MobileAppPromo/MobileAppPromo';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';

import screenTypeTelemetry from '../screenTypeTelemetry';

import './MobileAppPromo.less';

export function MobileAppPromoScreenType({
  applyData,
  onScreenTypeFinish,
  screenType,
}) {
  const {
    logFinish,
    logView,
  } = screenTypeTelemetry(screenType, applyData);

  useEffect(() => {
    logView();
  }, [logView]);

  const handleContinue = async () => {
    logFinish();
    await onScreenTypeFinish();
  };

  return (
    <div className="MobileAppPromoScreenType">
      <MobileAppPromo
        onContinue={handleContinue}
        screenType={screenType}
      />
    </div>
  );
}

MobileAppPromoScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenType: PropTypes.string.isRequired,
};

export default MobileAppPromoScreenType;
